/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { useIsLastAddedScroll } from "cms/common/hooks/use-is-last-added-scroll";
import { selectComposerLastComponentAdded, setLastComponentAdded } from "data/store/reducers/composer";

/**
 * Determines if the given component was the last one added
 * @param {string} guid
 */
const useIsLastAddedComponent = (guid) => {
    return useIsLastAddedScroll(
        guid,
        selectComposerLastComponentAdded,
        setLastComponentAdded
    );
};

export { useIsLastAddedComponent };
